import { Popover, PopoverContent, PopoverTrigger } from "./popover";
import { Calendar } from "./calendar";

type DateSelectProps = React.ComponentProps<typeof PopoverTrigger> & {
  selected?: Date;
  onSelect?: (date: Date | undefined) => void;
};

export function DateSelect({ selected, onSelect, ...props }: DateSelectProps) {
  return (
    <Popover modal={false}>
      <PopoverTrigger asChild {...props} />
      <PopoverContent>
        <Calendar mode="single" selected={selected} onSelect={onSelect} className="w-full" />
      </PopoverContent>
    </Popover>
  );
}
